const v: vInterFace = {
  pcWidth: 1366,
  spWidth: 750,
  breakPoint: 757,
  red: "#C83A26",
  pageTransition: 500,
};

export default v;
